import { useState } from "react";
import { faqs } from "@/mocks/comicData";

export default function Faq() {
  const [active, setActive] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-question-answer-line" />
            常见问题
          </span>
          <h2 className="font-heading mt-4 text-3xl text-foreground-950 md:text-4xl">
            关于访问，你可能想问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            整理了读者最常咨询的入口与访问问题，点击问题即可展开查看答案。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, idx) => {
            const isOpen = active === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-300 bg-primary-50/40" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setActive(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-bold text-foreground-950 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600"
                    }`}
                  >
                    <i className={`ri-add-line transition-transform ${isOpen ? "rotate-45" : ""}`} />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}